import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { IconButton, CircularProgress, Stack } from '@mui/material'
import { Save, Check, Undo } from '@mui/icons-material'

const PriceEntryButtons = ({ disabled, useMutation, payload, onSuccess, onError, onUndo }) => {
  const [mutation, { isLoading }] = useMutation()
  const [showCheck, setShowCheck] = useState(false)

  useEffect(() => {
    if (!disabled) {
      setShowCheck(false)
    }
  }, [disabled])

  const renderIcon = () => {
    if (isLoading) {
      return <CircularProgress size="1rem" />
    }
    if (showCheck) {
      return <Check fontSize="small" />
    }
    return <Save fontSize="small" />
  }

  return (
    <Stack width="100%" flexDirection="row" justifyContent="space-between">
      <IconButton
        color="primary"
        size="small"
        disabled={disabled}
        onClick={async () => {
          if (showCheck || isLoading) return
          await mutation(payload)
            .unwrap()
            .then(response => {
              onSuccess(response)
              setShowCheck(true)
            })
            .catch(onError)
        }}
      >
        {renderIcon()}
      </IconButton>
      <IconButton color="primary" size="small" disabled={isLoading || disabled} onClick={onUndo}>
        <Undo fontSize="small" />
      </IconButton>
    </Stack>
  )
}

PriceEntryButtons.propTypes = {
  disabled: PropTypes.bool,
  useMutation: PropTypes.func.isRequired,
  payload: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onUndo: PropTypes.func,
}

PriceEntryButtons.defaultProps = {
  disabled: true,
  onSuccess: () => {},
  onError: () => {},
  onUndo: () => {},
}

export default PriceEntryButtons
